
import React from 'react';
import { Brain } from 'lucide-react';
import { Account } from './types';

type EmptyStateProps = {
  selectedAccount: Account | null;
};

const EmptyState = ({ selectedAccount }: EmptyStateProps) => {
  return (
    <div className="bg-secondary/30 rounded-lg p-8 text-center">
      <Brain className="h-16 w-16 mx-auto mb-4 text-primary/50" />
      <h3 className="text-xl font-semibold text-primary-light mb-2">
        No Analysis Available
      </h3>
      <p className="text-primary-light/70 max-w-md mx-auto mb-6">
        Click "Generate Strategic Insights" to analyze customer data and receive AI-powered recommendations for your sales strategy.
      </p>
      {selectedAccount ? (
        <p className="text-xs text-primary-light/50">
          Account: {selectedAccount.company_name} ({selectedAccount.industry})
        </p>
      ) : (
        <p className="text-xs text-red-400">
          Please select an account in the Accounts tab first
        </p>
      )}
    </div>
  );
};

export default EmptyState;
